/*
  Lior Apple layer: App Store rows on phones, for the sections that switch on
  "גלילה לרוחב בנייד" (lior-apple-tiles, lior-apple-promise).
    [data-lar]          the section root
    [data-lar-track]    the list; on phones one row that snaps a card at a
                        time (the browser scrolls and snaps it, see the CSS)
    [data-lar-pager]    the page control under it, with a
    [data-lar-dot="i"]  button for each page
  - The page control follows the finger: each dot gets --k (0 → 1, how much
    it is the current one), so the long dot slides from dot to dot with the
    row. aria-current marks the card in view.
  - A tap on a dot, or on a card that only peeks in at the edge, brings that
    card in.
  - In the theme editor, selecting a block brings its card in.
  - From 768px the list is the section's grid again and none of this acts.
  Works in either direction: in Hebrew the row starts at the right.
*/
(function () {
  'use strict';

  if (window.__liorRow) return;
  window.__liorRow = true;

  var doc = document;
  var win = window;
  var mq = function (q) { return win.matchMedia ? win.matchMedia(q) : { matches: false }; };
  var phone = mq('(max-width: 767px)');
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var rows = [];

  function onChange(m, fn) {
    if (m.addEventListener) m.addEventListener('change', fn);
    else if (m.addListener) m.addListener(fn);
  }

  /* The list item of the track that holds el */
  function itemOf(track, el) {
    while (el && el.parentNode !== track) el = el.parentNode;
    return el || null;
  }

  function indexOf(track, li) {
    return Array.prototype.indexOf.call(track.children, li);
  }

  function Row(root) {
    var self = this;
    self.root = root;
    self.track = root.querySelector('[data-lar-track]');
    self.pager = root.querySelector('[data-lar-pager]');
    self.dots = self.pager ? Array.prototype.slice.call(self.pager.querySelectorAll('[data-lar-dot]')) : [];
    self.pages = [0];   /* scroll offset of each page, from the start of the row */
    self.pageOf = [];   /* card → page */
    self.k = [];
    self.current = -1;
    self.max = 0;
    self.rtl = false;
    self.queued = false;

    self.onScroll = function () { self.request(); };

    self.onDot = function (e) {
      var dot = e.target && e.target.closest ? e.target.closest('[data-lar-dot]') : null;
      if (!dot) return;
      self.go(Number(dot.getAttribute('data-lar-dot')));
    };

    /* A card that only peeks in at the edge comes in, instead of opening.
       (Not inside a card's own dialog, which sits in the list item too.) */
    self.onTap = function (e) {
      if (e.defaultPrevented || !self.active()) return;
      if (e.target && e.target.closest && e.target.closest('dialog')) return;
      var li = itemOf(self.track, e.target);
      if (!li) return;
      var t = self.track.getBoundingClientRect();
      var r = li.getBoundingClientRect();
      var seen = Math.min(r.right, t.right) - Math.max(r.left, t.left);
      if (!r.width || seen >= r.width * 0.6) return;
      e.preventDefault();
      e.stopPropagation();
      self.go(self.pageOf[indexOf(self.track, li)]);
    };

    self.track.addEventListener('scroll', self.onScroll, { passive: true });
    self.track.addEventListener('click', self.onTap);
    if (self.pager) self.pager.addEventListener('click', self.onDot);
    if ('ResizeObserver' in win) {
      self.ro = new ResizeObserver(function () { self.measure(); });
      self.ro.observe(self.track);
    }
    self.measure();
  }

  Row.prototype.active = function () {
    return phone.matches && this.max > 0;
  };

  /* How far the row has moved from its start, in pixels (RTL scrollLeft runs 0 → negative) */
  Row.prototype.offset = function () {
    var x = this.track.scrollLeft;
    return this.rtl ? -x : x;
  };

  /* Where each card snaps. Layout offsets, not boxes, so a card that is
     still sliding in (entrance) or pressed (scale) does not skew it. */
  Row.prototype.measure = function () {
    var t = this.track;
    var items = t.children;
    var pages = [];
    var pageOf = [];
    this.rtl = win.getComputedStyle(t).direction === 'rtl';
    this.max = Math.max(0, t.scrollWidth - t.clientWidth);
    if (items.length) {
      var first = items[0];
      var a = this.rtl ? first.offsetLeft + first.offsetWidth : first.offsetLeft;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var d = this.rtl ? a - (it.offsetLeft + it.offsetWidth) : it.offsetLeft - a;
        var p = Math.max(0, Math.min(this.max, Math.round(d)));
        /* the last cards may all stop at the end of the row: one page */
        if (!pages.length || p - pages[pages.length - 1] > 1) pages.push(p);
        pageOf.push(pages.length - 1);
      }
    }
    if (!pages.length) pages.push(0);
    this.pages = pages;
    this.pageOf = pageOf;

    for (var j = 0; j < this.dots.length; j++) {
      var hide = j >= pages.length;
      if (this.dots[j].hidden !== hide) this.dots[j].hidden = hide;
    }
    if (this.pager) {
      var off = phone.matches && pages.length < 2;
      if (this.pager.hidden !== off) this.pager.hidden = off;
    }
    this.sync(true);
  };

  /* The offset as a page number with a fraction: 1.4 is 40% of the way from page 2 to page 3 */
  Row.prototype.progress = function (s) {
    var P = this.pages;
    if (P.length < 2 || s <= P[0]) return 0;
    for (var i = 1; i < P.length; i++) {
      if (s <= P[i]) return i - 1 + (s - P[i - 1]) / ((P[i] - P[i - 1]) || 1);
    }
    return P.length - 1;
  };

  Row.prototype.request = function () {
    if (this.queued) return;
    this.queued = true;
    var self = this;
    requestAnimationFrame(function () {
      self.queued = false;
      self.sync(false);
    });
  };

  Row.prototype.sync = function (force) {
    var p = this.progress(this.offset());
    var dots = this.dots;
    for (var j = 0; j < dots.length; j++) {
      var k = Math.round(Math.max(0, 1 - Math.abs(p - j)) * 1000) / 1000;
      if (force || this.k[j] !== k) {
        this.k[j] = k;
        dots[j].style.setProperty('--k', String(k));
      }
    }
    var cur = Math.round(p);
    if (force || cur !== this.current) {
      this.current = cur;
      for (var i = 0; i < dots.length; i++) {
        if (i === cur) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
    }
  };

  /* Bring a page in: a glide (instant with reduced motion); the snap holds it there.
     scrollTo, not scrollBy: browsers treat scrollBy like an arrow key and stop at
     the next card (scroll-snap-stop), while scrollTo goes straight to the target. */
  Row.prototype.go = function (page, instant) {
    var P = this.pages;
    if (!(page >= 0 && page < P.length)) return;
    if (Math.abs(P[page] - this.offset()) < 1) return;
    var left = this.rtl ? -P[page] : P[page];
    var smooth = !instant && !reduce.matches;
    try {
      this.track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    } catch (e) {
      this.track.scrollLeft = left;
    }
  };

  Row.prototype.destroy = function () {
    this.track.removeEventListener('scroll', this.onScroll);
    this.track.removeEventListener('click', this.onTap);
    if (this.pager) this.pager.removeEventListener('click', this.onDot);
    if (this.ro) this.ro.disconnect();
  };

  /* ------------------------------------------------------------------ *
   * Wiring
   * ------------------------------------------------------------------ */
  function attach(root) {
    for (var i = 0; i < rows.length; i++) if (rows[i].root === root) return rows[i];
    if (!root.querySelector('[data-lar-track]')) return null;
    var row = new Row(root);
    rows.push(row);
    return row;
  }

  function scan(scope) {
    var s = scope || doc;
    if (s.matches && s.matches('[data-lar]')) attach(s);
    var roots = s.querySelectorAll('[data-lar]');
    for (var i = 0; i < roots.length; i++) attach(roots[i]);
  }

  function drop(scope) {
    rows = rows.filter(function (row) {
      if (scope === row.root || (scope.contains && scope.contains(row.root))) {
        row.destroy();
        return false;
      }
      return true;
    });
  }

  function remeasure() {
    for (var i = 0; i < rows.length; i++) rows[i].measure();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  onChange(phone, remeasure);
  win.addEventListener('pageshow', function (e) { if (e.persisted) remeasure(); });

  /* Theme editor */
  doc.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { drop(e.target); });

  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var root = t && t.closest ? t.closest('[data-lar]') : null;
    if (!root) return;
    var row = attach(root);
    if (!row) return;
    var li = itemOf(row.track, t);
    if (!li) return;
    var instant = !!(e.detail && e.detail.load);
    /* After the editor's own scroll to the block has started */
    requestAnimationFrame(function () {
      row.measure();
      if (row.active()) row.go(row.pageOf[indexOf(row.track, li)], instant);
    });
  });
})();
